import { Navigate } from "react-router-dom";
import { Layout } from "../components/Layout";
import { SportConfigTab } from "../components/sportConfig/SportConfigTab";
import { useAuth } from "../contexts/AuthContext";

/**
 * Pagina «Sport e modelli» (docs/sport-config, Fase 2). Guscio: autenticazione
 * e Layout; il resto sta in `SportConfigTab`, come per le altre sezioni coach.
 */
export default function SportConfig() {
	const { user } = useAuth();
	const isAdmin = user?.is_admin || user?.role === "admin";
	const isCoach = user?.role === "coach" || isAdmin;

	if (!isCoach) {
		return <Navigate to="/dashboard" replace />;
	}

	return (
		<Layout>
			<SportConfigTab />
		</Layout>
	);
}
